<template>
  <div
    class="modal fade"
    id="guidedPrompt"
    data-backdrop="static"
    data-keyboard="false"
    tabindex="-1"
    aria-labelledby="guidedPrompt"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Guided Creation</h5>
        </div>
        <div class="modal-body">
          {{ text }}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-hub-primary" @click="handleClick('Yes')">Yes</button>
          <button type="button" class="btn btn-secondary" @click="handleClick('No')">No</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    passed_state: {
      type: String,
      required: true
    },
    creation_object: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      current_state: this.passed_state
    }
  },
  computed: {
    ...mapGetters({
      guided_states: 'allGuidedStates'
    }),
    text: function () {
      switch (this.current_state) {
        case this.guided_states.ASK_CREATE_VISUALS:
          return 'Would you like to create visual(s)?'
        case this.guided_states.ASK_CREATE_STEPS:
          return 'Would you like to create step(s)?'
        case this.guided_states.ASK_CREATE_STEPS_AFTER_VISUAL:
          return 'Would you like to create step(s)?'
        case this.guided_states.ASK_CREATE_ANOTHER_VISUAL:
          return 'Would you like to create another visual?'
        case this.guided_states.ASK_CREATE_ANOTHER_STEP:
          return 'Would you like to create another step?'
        default:
          return 'Error!'
      }
    }
  },
  created () {},
  methods: {
    hide () {
      $('#guidedPrompt').modal('hide')
    },
    handleClick (text) {
      switch (this.current_state) {
        case this.guided_states.ASK_CREATE_VISUALS:
          if (text === 'Yes') {
            this.$store.dispatch('addEditAlert', { alert: this.creation_object, next: 'AdvancedVisualAdd' })
            this.hide()
          } else if (text === 'No') {
            this.current_state = this.guided_states.ASK_CREATE_STEPS
          }
          break
        case this.guided_states.ASK_CREATE_STEPS:
          if (text === 'Yes') {
            this.$store.dispatch('addEditAlert', { alert: this.creation_object, next: 'AlertStepAdd' })
            this.hide()
          } else if (text === 'No') {
            this.$store.dispatch('addEditAlert', { alert: this.creation_object, next: 'AlertSummary' })
            this.hide()
          }
          break
        case this.guided_states.ASK_CREATE_STEPS_AFTER_VISUAL:
          if (text === 'Yes') {
            this.$store.dispatch('addEditAdvancedVisual', {
              advanced_visual: this.creation_object,
              next: 'AlertStepAdd'
            })
            this.current_state = this.guided_states.ASK_CREATE_ANOTHER_VISUAL
            this.hide()
          } else if (text === 'No') {
            this.$store.dispatch('addEditAdvancedVisual', {
              advanced_visual: this.creation_object,
              next: 'AlertSummary'
            })
            this.hide()
          }
          break
        case this.guided_states.ASK_CREATE_ANOTHER_VISUAL:
          if (text === 'Yes') {
            this.$store.dispatch('addEditAdvancedVisual', {
              advanced_visual: this.creation_object,
              next: 'AdvancedVisualAdd'
            })
            this.hide()
          } else if (text === 'No') {
            this.current_state = this.guided_states.ASK_CREATE_STEPS_AFTER_VISUAL
          }
          break
        case this.guided_states.ASK_CREATE_ANOTHER_STEP:
          if (text === 'Yes') {
            this.$store.dispatch('addEditAlertStep', {
              alert_step: this.creation_object,
              next: 'AlertStepAdd'
            })
            this.hide()
          } else if (text === 'No') {
            this.$store.dispatch('addEditAlertStep', {
              alert_step: this.creation_object,
              next: 'AlertSummary'
            })
            this.hide()
          }

          break
      }
    }
  }
}
</script>

<style scoped>
</style>
